<template>
  <gj-modal
      size="full"
      :visible.sync="modalVisible"
      :confirmLoading="confirmLoading"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>新增广告活动</template>
    <template #content>
      <el-form
          ref="form"
          :model="form">
        <app-add-title style="padding-top: 0">广告活动</app-add-title>
        <app-campaign-base-info
            ref="base"
            :form="form.baseInfoForm"
            :maxTime="maxTime"
        ></app-campaign-base-info>
        
  
        <app-add-title>广告组</app-add-title>
        <el-form-item
            label="广告组名称"
            prop="groupName"
            :rules="[
              { required: true, message: '请输入广告组名称', trigger: ['change', 'blur'] }
            ]"
            label-width="100px">
          <gj-input
              v-model="form.groupName"
              width="334px"
              placeholder="请输入">
          </gj-input>
        </el-form-item>
  
  
        <app-add-title>投放类型</app-add-title>
        <app-target-type-picker
            ref="targetTypePicker"
            :form="form"
        ></app-target-type-picker>
  
        
        <app-add-title>商品</app-add-title>
        <app-product-picker
            ref="productPicker"
            :market-id="marketId"
            :form="form.productPickerForm"
            title="商品"
        ></app-product-picker>
  
        
        <app-add-title>竞价</app-add-title>
        <app-bid-picker
            ref="bidPicker"
            :form="form"
        ></app-bid-picker>
  
  
        <app-add-title>投放商品</app-add-title>
        
        <app-product-target-picker
            ref="productTargetPicker"
            :market-id="marketId"
            :form="form.productTargetPickerForm"
            title="商品投放"
            width="520px"
            :ad-product$="adProduct$"
        ></app-product-target-picker>
      
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn} from "../../../../../../../../minxins";
  import AppAddTitle from "../common/title";
  import AppProductPicker from "../common/product-picker";
  import {AdGroupEnum} from "../../../../../common/enum";
  import AppBidPicker from "../common/bid-picker";
  import AppCampaignBaseInfo from "../common/campaign-base-info";
  import AppTargetTypePicker from "../common/target-type-picker";
  import AppProductTargetPicker from "../common/product-target-picker";
  import {defaultVal, isMeaningful, isMeaningless} from "../../../../../../../../utils/common";
  import {addSdAdCampaign} from "../../../../../../../../api/ad";
  import {convertToDate} from "../../../../../../../../utils/date.util";
  import {adStoreMixin} from "../../../../../common/mixin";

  export default {
    name: "app-add-sd-ad-campaign",
    components: {
      AppProductTargetPicker,
      AppTargetTypePicker,
      AppCampaignBaseInfo,
      AppBidPicker,
      AppProductPicker, AppAddTitle
    },
    mixins: [modalMixIn, adStoreMixin],
    props: {
      marketId: {
        required: true,
      }
    },
    data() {
      return {
        form: {
          targetingType: AdGroupEnum.SD.targetingType.PRODUCT_TARGETING,
          baseInfoForm: {
            campaignName: null,
            budget: null,
            startDate: null,
            endDate: null,
          },
          groupName: null,
          productPickerForm: {
            items: []
          },
          defaultBid: 0.75,
          productTargetPickerForm: {
            items: [],
            bid: null
          }
        },
        adProduct$: null,
      }
    },
    created() {
      this.form.defaultBid = this.adStore.SD.defaultBid;
    },
    watch: {
      'form.productPickerForm.items': {
        handler(items) {
          if (isMeaningless(items) || items.length === 0) {
            return;
          }
          this.adProduct$ = Promise.resolve({
            records: (items || []).map(e => ({asin: e.asin}))
          });
        },
        immediate: false
      },
      'form.defaultBid': {
        handler(defaultBid) {
          this.form.productTargetPickerForm.bid = defaultBid;
        },
        immediate: true
      }
    },
    computed: {
      maxTime() {
        return this.adStore.SD.market?.datetime
      },
      createCampaignParams() {
        const params = {
          name: this.form.baseInfoForm.campaignName,
          tactic: this.form.targetingType,
          budget: this.form.baseInfoForm.budget,
          startDate: convertToDate(this.form.baseInfoForm.startDate),
          endDate: isMeaningful(this.form.baseInfoForm.endDate)
            ? convertToDate(this.form.baseInfoForm.endDate)
            : null,
        };
        return [params];
      },
      createGroupParams() {
        const params = {
          marketId: this.marketId,
          campaignName: this.form.baseInfoForm.campaignName,
          groupName: this.form.groupName,
          defaultBid: this.form.defaultBid,
          // TODO: 是否要传
          targetingType: AdGroupEnum.SD.targetingType.PRODUCT_TARGETING,
          // 商品
          adsProductCondition: {
            productParamList: this.form.productPickerForm.items.map(item => ({
              asin: item.asin,
              sku: item.msku
            }))
          }
        };
        
        if (this.form.targetingType === AdGroupEnum.SD.targetingType.PRODUCT_TARGETING) {
          // TODO: 确定参数内容
          params.adsTargetingCondition = {
            adsManualTargetingParamList: this.form.productTargetPickerForm.items.map(item => {
              const productTargetParams = {
                bid: item.bid
              };
              productTargetParams.id = defaultVal(item.categoryId, null);
              productTargetParams.asin = defaultVal(item.asin, null);
              productTargetParams.brandId = defaultVal(item.brandId, null);
              productTargetParams.lowPrice = defaultVal(item.lowPrice, null);
              productTargetParams.maxPrice = defaultVal(item.maxPrice, null);
              productTargetParams.marks = defaultVal(item.marks, null);
              productTargetParams.prime = defaultVal(item.prime, null);

              return productTargetParams;
            })
          };
        }
        
        return params;
      }
    },
    methods: {
      confirm() {
        // 验证子form
        let formValid = !['base', 'productPicker', 'bidPicker', 'productTargetPicker']
          .map(e => this.$refs[e])
          .filter(ref => isMeaningful(ref))
          .some(ref => !ref.formValidate());
        // 验证当前form
        this.$refs.form.validate((valid) => {
          formValid = formValid && valid;
        });
        if (formValid) {
          const params = {
            marketId: this.marketId,
            campaignName: this.form.baseInfoForm.campaignName,
            adsCampaignsParam: this.createCampaignParams,
            adsSdCreateGroupsCondition: this.createGroupParams
          };
          this.confirmLoading = true;
          addSdAdCampaign(params)
            .then(() => {
              this.$gjDestroy();
              this.$emit('created');
            })
            .complete(() => this.confirmLoading = false);
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../../../common/common";
/deep/.el-form-item {
  margin-bottom: 0;
}
/deep/.gj-add-title {
  padding-top: 24px;
}
</style>

